'use client';

import Breadcrumb from './Breadcrumb';
import LanguageSwitcher from './LanguageSwitcher';
import { IBreadcrumbItem } from '@/interfaces';
import { Language } from '@/lib/translations';

interface TitleBarSubProps {
  language: Language;
  className?: string;
  // Explicit breadcrumb items; when omitted they are derived from the pathname
  breadcrumbItems?: IBreadcrumbItem[];
}

export default function TitleBarSub({
  language,
  className = '',
  breadcrumbItems,
}: TitleBarSubProps) {
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div className="flex-1">
        <Breadcrumb language={language} items={breadcrumbItems} />
      </div>
      <LanguageSwitcher language={language} />
    </div>
  );
}
